import axios from '@/axios';

interface Options {
  locationId: string;
  resourceId?: number | null;
  serviceIds?: number[];
}

interface Params {
  resource_id?: number;
  service_ids?: number[];
}

export const loadFirstAvailability = ({
  locationId,
  resourceId,
  serviceIds
}: Options) => {
  const params: Params = {
    service_ids: serviceIds
  };

  if (resourceId) {
    params.resource_id = resourceId;
  }

  return axios
    .get(`/locations/${locationId}/availabilities/first`, { params })
    .then((response) => {
      if (response.status === 200) {
        return response.data;
      }
      return null;
    })
    .catch((e) => {
      throw new Error('Server error.', e);
    });
};
